/* PRE-STEP 4 · Part 2 — Founder → Maintenance, the "old copies and orphans report" run: its XLSX download. EN + AR.
   Loaded from lib/i18n/ by the generated index (STEP 2 · B2). */
export const I18N_OCR = {
  en: {
    ocr: {
      downloadXlsx: "Download XLSX",
      downloadTitle: "The five sections of this run as a workbook (EN + AR headings)",
      downloadFailed: "Could not download the report file",
      dataHidden: "{n} data line(s) for the XLSX are not shown",
    },
  },
  ar: {
    ocr: {
      downloadXlsx: "تنزيل ملف XLSX",
      downloadTitle: "الأقسام الخمسة لهذا التشغيل في مصنف (عناوين بالإنجليزية والعربية)",
      downloadFailed: "تعذّر تنزيل ملف التقرير",
      dataHidden: "لا تُعرض {n} سطر/أسطر بيانات ملف XLSX",
    },
  },
};

export default I18N_OCR;
